import { splitOnTerms } from '@/lib/search';

/**
 * Renders `text` with each search term marked. Orange, not yellow: the SOP
 * reader highlights quoted passages in yellow and both can be on screen at once.
 */
export const HighlightedText = ({ text, terms }: { text: string; terms: string[] }) => (
	<>
		{splitOnTerms(text, terms).map((part, i) =>
			part.match ? (
				<mark key={i} className='rounded-[2px] bg-orange-200/75 text-inherit'>
					{part.text}
				</mark>
			) : (
				part.text
			)
		)}
	</>
);
